<button
  type="button"
  class="fab"
  [class.open]="expanded()"
  [class.gone]="hidden()"
  [attr.aria-hidden]="hidden() ? true : null"
  [attr.tabindex]="hidden() ? -1 : null"
  aria-label="Open the SHOUT Tour-Guide assistant"
  (click)="open()">
  <span class="pulse" aria-hidden="true"></span>
  <span class="fab-orb" aria-hidden="true">
    <img src="../../../../assets/logos/official/SHOUT_icon_white.svg" class="size-6" alt="SHOUT Logo">
  </span>
  <span class="fab-txt">
    <p class="fab-title m-0">Want some help?</p>
    <p class="fab-subtitle m-0">Chat to the SHOUT Tour-Guide</p>
  </span>
</button>
